<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>money</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Cajas</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList"
                >
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-text-field
                    clearable
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Descripción"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <td class="text-xs-left">{{ item.descripcion }}</td>
                      <td class="text-xs-left">
                        {{ item.tipoCajaDescripcion }}
                      </td>
                      <td class="text-xs-left">{{ item.sucursalNombre }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>

            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarDetail"
                >
                  <v-icon>money</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate"
                  >
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="model.id != null"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate"
                  >
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="model.descripcion"
                          label="Descripción"
                          required
                          :disabled="!editMode"
                          v-validate="'required'"
                          data-vv-name="descripcion"
                          :error-messages="errors.collect('descripcion')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="model.tipoCajaId"
                          :items="tiposCaja"
                          item-text="descripcion"
                          item-value="id"
                          label="Tipo de Caja"
                          placeholder="Seleccione un tipo de caja"
                          :disabled="!editMode"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-radio-group
                          v-model="asociarACanalVenta"
                          column
                          :disabled="!editMode"
                        >
                          <v-radio
                            :value="false"
                            label="Asociar a Sucursal"
                            checked
                          ></v-radio>
                          <v-radio
                            :value="true"
                            label="Asociar a Canal de venta"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="6" v-if="!asociarACanalVenta">
                        <v-autocomplete
                          v-model="model.sucursalId"
                          :items="sucursales"
                          item-text="nombre"
                          item-value="id"
                          label="Sucursal"
                          placeholder="Seleccione una Sucursal"
                          :disabled="!editMode"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" v-if="asociarACanalVenta">
                        <v-autocomplete
                          v-model="model.canalVentaId"
                          :items="canalesVenta"
                          item-text="nombre"
                          item-value="id"
                          label="Canal de Venta"
                          placeholder="Seleccione un Canal de Venta"
                          :disabled="!editMode"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="model.saldoMinimo"
                          label="Saldo Mínimo"
                          type="number"
                          prefix="$"
                          :disabled="!editMode"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="model.saldoMaximo"
                          label="Saldo Máximo"
                          type="number"
                          prefix="$"
                          :disabled="!editMode"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="
                        $store.state.parametrosGenerales.cajaPermiteMultiMoneda
                      "
                    >
                      <v-col cols="6">
                        <v-switch
                          v-model="model.multiMoneda"
                          label="Es Caja Multi-Moneda"
                          :disabled="!editMode"
                        ></v-switch>
                      </v-col>
                      <v-col cols="6">
                        <v-switch
                          v-model="model.requiereBancoAcreditacion"
                          label="Requiere Banco Acreditacion"
                          :disabled="!editMode"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-switch
                          v-model="model.replicaCobranzaEnOtraCaja"
                          label="Replica Cobranza en otra Caja"
                          :disabled="!editMode"
                        ></v-switch>
                      </v-col>
                      <v-col cols="6" v-if="model.replicaCobranzaEnOtraCaja">
                        <v-autocomplete
                          v-model="model.cajaReplicacionId"
                          :items="cajasOtraEmpresaDisponibles"
                          item-text="descripcion"
                          item-value="id"
                          label="Cajas de Otra Empresa"
                          placeholder="Seleccione una Caja en donde replicar las cobranzas"
                          :disabled="!editMode"
                        ></v-autocomplete>
                      </v-col>
                       <v-col cols="6">
                       <v-autocomplete
                          v-model="model.formatosEnvioDebitoId"
                          :items="formatosEnvioDebito"
                          item-text="descripcion"
                          item-value="id"
                          label="Formato Envío Débito"
                          placeholder="Seleccione un formato"
                          :disabled="!editMode"
                          ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                      <p></p>
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        { text: 'Descripción', value: 'descripcion', align: 'left' },
        { text: 'Tipo', value: 'tipoCajaDescripcion', sortable: false },
        { text: 'Sucursal', value: 'sucursalNombre', sortable: false },
        { text: 'Acciones', value: 'name', sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      model: {},
      tiposCaja: [],
      sucursales: [],
      canalesVenta: [],
      formatosEnvioDebito: [],
      cajasOtraEmpresa: [],
      asociarACanalVenta: false,
      empresaCajaSeleccionadaId: 0,
    };
  },
  async created() {
    this.getItems();
    this.loadTiposCaja();
    this.loadSucursales();
    this.loadCanalesVenta();
    this.loadCajasOtraEmpresa();
    this.loadFormatosEnvioDebito();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
  },
  computed: {
    ...mapGetters([
      'checkCanCreate',
      'checkCanUpdate',
      'checkCanDelete',
      'getActionFromLink',
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    cajasOtraEmpresaDisponibles: function () {
      console.log('this.selectedRow ');
      console.log(this.selectedRow);
      if (this.selectedRow.length > 0 && this.selectedRow[0].empresaId > 0) {
        console.log(this.selectedRow[0].empresaId);
        return this.cajasOtraEmpresa.filter(
          (x) => x.empresaId != this.selectedRow[0].empresaId
        );
      } else return this.cajasOtraEmpresa;
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          'cajas?descOCodigo=' +
            this.search +
            '&limits=' +
            this.options.itemsPerPage +
            '&page=' +
            this.options.page +
            '&sortby=' +
            this.options.sortBy +
            '&descending=' +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false')
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get('cajas/' + id);

        this.model = result;

        this.asociarACanalVenta = !(this.model.canalVentaId === 0);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = {};
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem(0);
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      if (!this.asociarACanalVenta) this.model.canalVentaId = 0;

      if (isUpdate) {
        try {
          await http.put('cajas', JSON.stringify({ caja: this.model }));
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          await http.post('cajas', JSON.stringify({ caja: this.model }));
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      if (
        confirm('¿Confirma la eliminación de la caja ' + item.descripcion + '?')
      ) {
        try {
          Vue.$log.debug(item);
          await http.delete('cajas?id=' + item.id);
          this.alertSuccess('La caja ha sido eliminada.');
          this.clearAndReload();
        } catch (error) {
          //Error
          Vue.$log.error(error);
          if (
            error.includes(
              'The DELETE statement conflicted with the REFERENCE constraint'
            )
          ) {
            this.alertError(
              'La caja no puede ser eliminada debido a que está asociada a otras entidades.'
            );
          } else {
            this.alertError(error);
          }
        }
      }
    },
    async loadCajasOtraEmpresa() {
      this.loading = true;
      try {
        var result = await http.get('cajas');
        Vue.$log.debug('cajas');

        this.cajasOtraEmpresa = result.list;
        Vue.$log.debug(this.cajasOtraEmpresa);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposCaja() {
      this.loading = true;
      try {
        var result = await http.get('tiposcaja');
        Vue.$log.debug('tiposcaja');

        this.tiposCaja = result.list;
        Vue.$log.debug(this.tiposCaja);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get('sucursales');

        this.sucursales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get('canalesventa?limit=9999');

        this.canalesVenta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormatosEnvioDebito() {
      this.loading = true;
      try {
        var result = await http.get('archivosDebito/formatosenvio');

        this.formatosEnvioDebito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
